import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ObjectiveListComponent } from './objective-list/objective-list.component';
import { ObjectiveCreateComponent } from './objective-create/objective-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: ObjectiveListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: ObjectiveCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'objective-create/:id',
        component: ObjectiveCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ObjectiveRoutingModule { }
